import i18next from "i18next";
import apiClient from "@/app/api/client";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import type { AppLocale } from "./constants";
import { LOCALE_STORAGE_KEY } from "./constants";

/**
 * Til almashtirish (P7 spec §6): `i18next.changeLanguage` → `localStorage`
 * → `apiClient`ning standart sarlavhasi → (autentifikatsiyalangan bo'lsa)
 * profilga yozish.
 *
 * ⚠️ `i18next` shu yerda TO'G'RIDAN-TO'G'RI npm paketidan olinadi
 * (`./index.ts`dan EMAS) — sabab shu faylning izohiga qarang
 * (`import.meta.glob` `bun test` ostida ishlamaydi). Ikkalasi ham bir xil
 * modul singletoniga ishora qiladi: brauzerda `main.tsx` `./index.ts`ni
 * import qilib singletonni ALLAQACHON ishga tushirgan bo'ladi, bu fayl
 * esa faqat o'sha bitta nusxani chaqiradi.
 *
 * ⚠️ `useAuthStore.getState()` — hook render vaqtidagi qiymat EMAS,
 * chaqirilish vaqtidagi qiymat. Funksiya bosilgan tugma callback'ida
 * keyinroq ishlatilishi mumkin, shuning uchun `useAuthStore(selector)`
 * bilan yozilgan bo'lsa eskirgan yopilish (stale closure) xavfi bo'lardi.
 */
export function useChangeLocale(): (locale: AppLocale) => Promise<void> {
	return async function changeLocale(locale: AppLocale) {
		await i18next.changeLanguage(locale);

		try {
			window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
		} catch {
			// Xususiy rejim yoki disk to'la — joriy sessiya uchun baribir ishlaydi.
		}

		apiClient.defaults.headers.common["X-Locale"] = locale;

		if (useAuthStore.getState().isAuthenticated) {
			try {
				await apiClient.patch("/users/me/locale", { locale });
			} catch {
				// ⚠️ Profilga yozish muvaffaqiyatsiz bo'lsa ham UI tili DARHOL
				// almashgan bo'ladi (yuqoridagi qatorlar allaqachon bajarilgan) —
				// tarmoq xatosi tufayli foydalanuvchini "til o'zgarmadi" holatida
				// qoldirmaslik uchun bu yerda qayta uloqtirilmaydi. Keyingi
				// qurilma/sessiyada standart tilga qaytish — qabul qilinadigan
				// chekka holat, chunki `X-Locale` sarlavhasi joriy sessiya
				// davomida baribir ustuvor.
			}
		}
	};
}
